// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2G_J3","list":"styles_list__3YXg1"};